
export const UPDATE = 'UPDATE';
export const REMOVE = 'REMOVE';

const defaultState = {
  generalState1: false, // example
  map: {}
};

// also create
export function update (map, id, item) {
    map[id] = item;
    return Object.assign({}, map);
}

export function remove (map, id) {
    delete map[id];
    return Object.assign({}, map);
}

/**
 * viewcontrollers reducer
 * @param {Object} [state=defaultState] the previous state
 * @param {Object} action the action to apply
 * @return {Object} the new state
 */
export default function (state = defaultState, action) {
  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        map: update(state.map, action.id, action.item)
      };
    case REMOVE:
      return {
        ...state,
        map: remove(state.map, action.id)
      };
    default:
      return state;
  }
}
